import { render, staticRenderFns } from "./PowerRankingsArchives.vue?vue&type=template&id=34d09784&"
import script from "./PowerRankingsArchives.vue?vue&type=script&lang=js&"
export * from "./PowerRankingsArchives.vue?vue&type=script&lang=js&"
import style0 from "./PowerRankingsArchives.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports